export * from './extra-vereinbarungen.component';
export * from './extra-vereinbarungen.component.module';